<template>
	<div>
		<div v-if="isInterested" class="mt-4">
			<template v-if="!successfullyAccepted">
				<h3 class="color-primary">Du bist noch anonym!</h3>
				<div>Deine persönlichen Daten (wie Namen, bisherige Arbeitgeber, Wohnort, usw.) sind noch nicht
					sichtbar.
				</div>
				<div class="mt-3">
					<div>Dein Interesse am Jobprofil:</div>
					<div class="font-weight-extra-bold">{{ message.jobProfile.info }}</div>
				</div>
				<div class="mt-3">
					{{ customerName }} von {{ companyName }}
					<span v-if="customerWebsite">(<a :href="customerWebsite" target="_blank">{{ customerWebsite }}</a>)</span>
					hat dir die Anfrage gesendet.<br/>
					Der Job ist noch nicht besetzt! Um Hintergrundinformationen zur Stelle zu erfahren und deine Chancen
					zu sichern, bestätige bitte umgehend die Kontaktanfrage.<br/> {{ customerName }}
					von {{ companyName }} wird informiert und meldet sich über skilldoo bei dir.
				</div>
				<div class="mt-3 font-size-small">
					Wenn du auf "Kontaktanfrage bestätigen" drückst, werden von deinem Profil folgende Daten
					offengelegt:<br/>
					Vorname, Nachname und Geburtsjahr.<br/>
					<u>Nicht</u> offengelegt werden deine Telefonnummer, E-Mail Adresse, genauer Wohnort (Postleitzahl,
					Straße, Hausnummer).
				</div>
			</template>
		</div>
		<div v-if="isNotInterested" class="mt-4">
			<h3>Verabschiedung</h3>
			<div class="mt-2">
				Dieses Jobprofil <span class="font-weight-extra-bold">{{ message.jobProfile.info }}</span>
				wurde angezeigt, weil es eine entsprechende Übereinstimmung mit deinem Jobwunsch gibt.<br/>
				Damit in Zukunft noch genauer die für dich passenden Jobs angezeigt werden, passe bitte dein
				Wunschprofil an.
			</div>
		</div>
		<div v-if="isCustomerUninteresting" class="mt-4">
			<ApplicantSendOff
				v-model="applicantSendoffData"
				:customer="message.customer"
				@input="applicantSendoffDataChanged"
			/>
		</div>
	</div>
</template>
<script>
import Button from "@/vue/common/Button";
import Reply, {ACTION_ACCEPT, ACTION_SENDOFF} from "@/api/communication/conversation/message/Reply";
import {isDefined} from "@/helper/Value";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import ApplicantSendOff from "@/vue/communication/conversation/ApplicantSendOff";

const CHOICE_INTERESTED = 'interested';
const CHOICE_NOT_INTERESTED = 'not-interested';
const CHOICE_CUSTOMER_UNINTERESTING = 'customer-uninteresting';

export default {

	components: {
		ApplicantSendOff,
		Button
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			choice: undefined,
			successfullyAccepted: false,
			successfullySentOff: false,
			applicantSendoffData: undefined,
		};
	},

	computed: {
		customerName ()
		{
			return this.message.customer.nameWithSalutation;
		},
		customerWebsite ()
		{
			return this.message.customer.website;
		},
		companyName ()
		{
			return this.message.customer.companyName;
		},
		isInterested ()
		{
			return this.choice === CHOICE_INTERESTED;
		},
		isNotInterested ()
		{
			return this.choice === CHOICE_NOT_INTERESTED;
		},
		isCustomerUninteresting ()
		{
			return this.choice === CHOICE_CUSTOMER_UNINTERESTING;
		},
		customerUninterestingValid ()
		{
			return !this.isCustomerUninteresting || isDefined(this.applicantSendoffData);
		}
	},

	methods: {
		interested ()
		{
			this.choice = CHOICE_INTERESTED;

			this.$nextTick(() => this.$emit('contentGrow'));
		},
		interestedRevert ()
		{
			this.choice = undefined;

			this.$nextTick(() => this.$emit('contentGrow'));
		},
		notInterested ()
		{
			this.choice = CHOICE_NOT_INTERESTED;

			this.$nextTick(() => this.$emit('contentGrow'));
		},
		notInterestedRevert ()
		{
			this.choice = undefined;

			this.$nextTick(() => this.$emit('contentGrow'));
		},
		customerUninteresting ()
		{
			this.choice = CHOICE_CUSTOMER_UNINTERESTING;
		},
		customerUninterestingRevert ()
		{
			this.applicantSendoffData = undefined;

			this.choice = CHOICE_INTERESTED;

			this.applicantSendoffDataChanged();
		},
		applicantSendoffDataChanged ()
		{
			this.$emit('sendoffDataChanged', this.applicantSendoffData);
		},
		async sendRequest ()
		{
			this.$emit('loading', true);

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(
						this.isInterested
							? ACTION_ACCEPT
							: ACTION_SENDOFF
					)
					.setCustomerUninterestingType(
						this.isCustomerUninteresting
							? this.applicantSendoffData.customerUninterestingType
							: undefined
					)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.$emit('loading', false);
		}
	},
}
</script>
